"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ScreenClassResolver_1 = __importDefault(require("../../context/ScreenClassResolver"));
var ScreenClassRender = function (_a) {
    var render = _a.render;
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) { return render(screenClass); } }));
};
exports.default = ScreenClassRender;
//# sourceMappingURL=index.js.map